<div class="subscription">
    <div class="d-flex flex-column position-relative awb-subscription full-screen">
        <button
            mat-icon-button
            mat-dialog-close
            aria-label="Close AWB subscribtion"
            class="position-absolute end-0 top-0 p-0 aling-center"
        >
            <mat-icon>close</mat-icon>
        </button>
        <app-facility-logo class="mt-3" [width]="'140'" [height]="'102'" />
        <h2 class="mat-headline-6 mb-3 mt-5 awb" color="primary">AWB: {{ awb }}</h2>
        <h4 class="mat-headline-4 mb-4 title">MAWB alert and automatic payment consent.</h4>
        <div class="mat-subtitle-1 text-header">
            Dear Customer, the <strong>MAWB number</strong> you have queried has not arrived and/or been invoiced by
            {{ facilityName }}. Below you can either <strong>subscribe to be notified</strong> when the shipment is
            available, or enroll in our
            <strong>AutoPay feature which allows for ISC payments at the MAWB level.</strong>
        </div>
        <div class="mt-3">
            <app-mawb-subscription />
        </div>
        <mat-divider class="mb-3" />
        <app-auto-pay />
        <div>
            <strong>Privacy Notice:</strong> Your contact information will only be used for notifying you regarding the
            status of your MAWB and for no other purpose. For more information, please review our
            <a [href]="privacyAndPolicyURL | sanitize: 'url'" target="_blank"> Privacy Policy. </a>
        </div>
        <app-auto-pay-policy />
        <div class="mt-5 d-flex justify-content-end">
            <button matButton="outlined" appMatStrokedButtonBorder mat-dialog-close color="primary" class="me-2">
                CANCEL
            </button>
            @if (showButtonSubmit) {
                <button
                    matButton="filled"
                    type="submit"
                    color="primary"
                    (click)="submit()"
                    [disabled]="!isAllowedToContinue"
                >
                    {{ isSelectedSubscription?.value && !isSelectedAutoPay?.value ? 'SUBSCRIBE' : 'SUBMIT' }}
                    @if (subscribing) {
                        <mat-icon class="ms-2 spinner-icon" iconPositionEnd>
                            <mat-spinner diameter="16" />
                        </mat-icon>
                    }
                </button>
            }
        </div>
    </div>
</div>
